<template>
  <div class="vertical">
    <vue-dialog
      :color="data_color"
      v-if="show_dialog"
      :name="data_name"
      :left="data_left"
      :right="data_right"
      :title="data_title"
      :value="data_value"
      @dialog_end="dialogend"
    >
    </vue-dialog>
    <div class="top">
      {{ uppercase(main_data.loc_select.title) }}
    </div>
    <div class="middle">
      <div class="left">
        <img src="../../assets/images/desktop/globus.png" alt="" />
      </div>
      <div class="right">
        <div class="location-row type_1">
          <div class="img-container" style="width: 3.88rem;">
            <img src="../../assets/images/city_logo.png" />
          </div>
          <div class="select-container-1">
            <select :value="main_data.loc_city.value" @change="valuechange('loc_city', $event.target.value)">
              <option
                :key="'city' + index"
                v-for="(city_shortcut, index) in main_data.loc_country.data[main_data.loc_country.value]['city_data']"
                :value="city_shortcut"
              >
                {{ main_data.loc_city.select[city_shortcut] }}
              </option>
            </select>
          </div>
        </div>
        <div class="location-row type_3">
          <div class="text-container blue">
            {{ main_data.app_additional_options.title }}
          </div>
          <vue-checkbox
            :value="main_data.loc_additional_data.value"
            @input="set_additional"
            :class="{ 'vue-checkbox': true, blue: main_data.loc_additional_data.value }"
          >
          </vue-checkbox>
        </div>
        <div :class="{ 'location-row': true, type_2: true, blue: main_data.loc_additional_data.value }">
          <div class="img-container" style="width: 4.64rem;">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              id="Wind"
              width="46.424"
              height="33.072"
              viewBox="0 0 46.424 33.072"
            >
              <path
                id="Wind_01"
                fill="currentColor"
                d="M-366.489 288.865c-22.86-2.339-26.794-2.764-26.794-2.764-.319 0 .532-.425-13.078 6.379v-2.98a1.18 1.18 0 0 0-1.17-1.169 1.18 1.18 0 0 0-1.17 1.169V318a1.18 1.18 0 0 0 1.17 1.17 1.18 1.18 0 0 0 1.17-1.17v-18.4l12.546 6.273c.319.106 2.871-.106 27.219-2.977 5.742-.315 5.742-13.606.107-14.031zm-39.872 8.825v-3.3l9.782-4.891a17.5 17.5 0 0 0 .319 13.291zm21.478 4.785c-3.083-3.721-3.3-9.676-.213-12.972l6.273.425a11.816 11.816 0 0 0 .213 12.121zm18.283-1.275c-1.063 0-2.552-1.17-2.552-5.21s1.488-5.423 2.552-5.423 2.552 1.382 2.552 5.423c.111 4.039-1.378 5.21-2.552 5.21z"
                transform="translate(408.7 -286.095)"
              />
            </svg>
          </div>
          <div class="select-container-1">
            <select
              :disabled="!main_data.loc_additional_data.value"
              :value="main_data.loc_wind.value"
              @change="valuechange('loc_wind', $event.target.value, true)"
            >
              <option
                :key="'wind' + index"
                v-for="(text, index) in main_data.loc_wind.select"
                :value="main_data.loc_wind.data[index]"
              >
                {{ text }}
              </option>
            </select>
          </div>
        </div>
        <div :class="{ 'location-row': true, type_2: true, blue: main_data.loc_additional_data.value }">
          <div class="img-container" style="width: 4.83rem;">
            <svg xmlns="http://www.w3.org/2000/svg" id="Sun" width="48.294" height="48.281" viewBox="0 0 48.294 48.281">
              <path
                id="XMLID_1061_"
                fill="currentColor"
                fill-rule="evenodd"
                d="M8.315 24.141A1.975 1.975 0 0 0 6.3 22.129H2.012A2.063 2.063 0 0 0 0 24.141a1.975 1.975 0 0 0 2.012 2.012h4.157a1.937 1.937 0 0 0 2.146-2.012zm2.012 11.8a2.154 2.154 0 0 0-1.475.671L6.035 39.43a2.154 2.154 0 0 0-.671 1.475 1.975 1.975 0 0 0 2.012 2.012 2.154 2.154 0 0 0 1.475-.671l2.816-2.816a2.154 2.154 0 0 0 .671-1.475 1.9 1.9 0 0 0-2.012-2.012zM24.141 8.315A1.975 1.975 0 0 0 26.152 6.3V2.012A1.9 1.9 0 0 0 24.141 0a1.975 1.975 0 0 0-2.012 2.012v4.157a2.093 2.093 0 0 0 2.012 2.146zm13.814 4.158a2.154 2.154 0 0 0 1.475-.673l2.816-2.816a1.651 1.651 0 0 0 .671-1.341 1.975 1.975 0 0 0-2.017-2.01 2.154 2.154 0 0 0-1.47.667l-2.817 2.82a2.154 2.154 0 0 0-.671 1.475 2.044 2.044 0 0 0 2.012 1.878zM8.852 11.8a2.154 2.154 0 0 0 1.475.671 1.975 1.975 0 0 0 2.012-2.012 2.154 2.154 0 0 0-.671-1.475L9.12 6.169A2.154 2.154 0 0 0 7.645 5.5a1.975 1.975 0 0 0-2.012 2.01A2.154 2.154 0 0 0 6.3 8.986zM46.27 22.129h-4.158a2.012 2.012 0 1 0 0 4.023h4.158a1.975 1.975 0 0 0 2.012-2.012 1.9 1.9 0 0 0-2.012-2.012zm-6.84 14.484a2.154 2.154 0 0 0-1.475-.671 1.975 1.975 0 0 0-2.012 2.012 2.154 2.154 0 0 0 .671 1.475l2.816 2.816a2.154 2.154 0 0 0 1.475.671 1.975 1.975 0 0 0 2.012-2.012 2.154 2.154 0 0 0-.671-1.475zM24.141 40.1a1.975 1.975 0 0 0-2.012 2.012v4.158a2.012 2.012 0 1 0 4.023 0v-4.158a1.9 1.9 0 0 0-2.011-2.012zm0-30.444a14.484 14.484 0 1 0 14.484 14.485A14.51 14.51 0 0 0 24.141 9.656zm0 24.945a10.327 10.327 0 1 1 10.326-10.326A10.331 10.331 0 0 1 24.141 34.6zm0 0"
              />
            </svg>
          </div>
          <div class="select-container-1">
            <select
              :disabled="!main_data.loc_additional_data.value"
              :value="main_data.loc_sun.value"
              @change="valuechange('loc_sun', $event.target.value, true)"
            >
              <option
                :key="'sun' + index"
                v-for="(text, index) in main_data.loc_sun.select"
                :value="main_data.loc_sun.data[index]"
              >
                {{ text }}
              </option>
            </select>
          </div>
        </div>
        <div :class="{ 'location-row': true, blue: main_data.loc_additional_data.value }">
          <div :class="{ 'text-container': true }">{{ main_data.loc_internal.title }}</div>
          <div class="select-container-2">
            <select
              :disabled="!main_data.loc_additional_data.value"
              :value="main_data.loc_internal.value"
              @change="valuechange('loc_internal', $event.target.value, true)"
            >
              <option value="18">18&deg;C</option>
              <option value="19">19&deg;C</option>
              <option value="20">20&deg;C</option>
              <option value="21">21&deg;C</option>
              <option value="22">22&deg;C</option>
              <option value="23">23&deg;C</option>
              <option value="24">24&deg;C</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom" @click="$emit('confirm-step', 0)">
      {{ main_data.app_confirm.title }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.vertical {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 96.7rem;

  .top {
    margin-top: 0.9rem;
    font-family: F-Dem;
    font-size: 3.4rem;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: center;
    color: $text_white;
    flex-grow: 0;
  }

  .middle {
    display: flex;
    justify-content: space-between;
    flex-grow: 0;
    height: 41.1rem;
    width: 97.4rem;
    margin: 0 auto;
    align-items: center;

    .left {
      width: 63rem;
      position: relative;
      pointer-events: none;

      img {
        width: 100%;
        max-width: 100%;
      }
    }

    .right {
      width: 41.4rem;

      .location-row {
        height: 4.8rem;
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        color: $main_header_middle;

        &.type_1 {
          margin-bottom: 4rem;
        }

        &.type_2 {
          margin-bottom: 2.37rem;
        }

        &.type_3 {
          height: 3rem;
          margin-bottom: 3rem;
        }

        &.blue {
          color: $desktop_blue;
        }

        .img-container {
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 100%;
            max-width: 100%;
            height: auto;
          }
        }

        .select-container-1 {
          width: 32.5rem;
        }

        .select-container-2 {
          width: 14rem;
        }

        .text-container {
          font-size: 2.1rem;
          line-height: 0.86;
          text-align: left;
          align-self: center;

          &.blue {
            color: $desktop_blue;
          }
        }

        select {
          width: 100%;
          height: 100%;
          border-radius: 2.4rem;
        }

        select:not([disabled]) {
          background-image: url("../../assets/images/desktop/location_select_arrow.svg");
        }

        .vue-checkbox {
          height: 3rem;
          width: 3rem;
          border: 2px solid $desktop_blue_border;
          background-color: $main_header_middle;

          &.blue {
            background-color: $desktop_blue_border;
            border: none;
          }
        }
      }
    }
  }

  .bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 3rem auto;
    background-color: $desktop_blue;
    height: 7rem;
    width: 26.4rem;
    border-radius: 3.5rem;
    font-size: 2.5rem;
    line-height: 1.16;
    color: $text_white;
    flex-grow: 0;
    cursor: pointer;
  }
}
</style>

<script>
import mixin from "../../lib/mixins.js";
import checkbox from "../../components/checkbox.vue";
import dialog from "../../components/dialog";
import superconsole from "../../lib/superconsole.js";

export default {
  mixins: [mixin],
  props: ["main_data", "get_intervention_exists"],
  components: {
    "vue-checkbox": checkbox,
    "vue-dialog": dialog,
  },
  data: function () {
    return {
      show_dialog: false,
      data_title: "",
      data_name: "",
      data_left: "",
      data_right: "",
      data_color: "",
      data_value: {},
      promise: null,
    };
  },
  methods: {
    pre_approve: async function (name, value) {
      return new Promise((res) => {
        this.promise = res;
        this.dialogstart(name, value);
      });
    },
    dialogstart: async function (name, value) {
      const showDialog = (title, intervention, color = "#2db46a") => {
        this.data_title = title;
        this.data_left = this.main_data.app_proceed.title;
        this.data_right = this.main_data.app_cancel.title;
        this.data_value = { name: name, value: value };
        this.data_name = intervention;
        this.show_dialog = true;
        this.data_color = color;
      };

      if ((name === "loc_country" || name === "loc_city") && this.get_intervention_exists) {
        showDialog(this.main_data.app_intervention_reset.title, "all", "#04b7fb");
      } else {
        this.promise(true);
      }
    },
    dialogend: function (ev) {
      if (ev.confirm) {
        this.$emit("reset-whole-intervention");
        this.promise(true);
      } else {
        this.promise(false);
      }

      this.show_dialog = false;
    },
    valuechange: async function (name, value, isnumber, approved) {
      if (isnumber) {
        value = +value;
      }

      if (!approved) {
        if (!(await this.pre_approve(name, value))) return;
      }

      // eslint-disable-next-line
      superconsole.log("emit", name, value);

      this.$emit("value-change", {
        name: name,
        value: value,
      });
    },
    set_additional: function () {
      if (this.main_data.loc_additional_data.value) {
        this.$emit("value-change", {
          name: "loc_sun",
          value: this.main_data.loc_sun.value_default,
        });
        this.$emit("value-change", {
          name: "loc_wind",
          value: this.main_data.loc_wind.value_default,
        });
        this.$emit("value-change", {
          name: "loc_internal",
          value: this.main_data.loc_internal.value_default,
        });
      }
      this.$emit("value-change", {
        name: "loc_additional_data",
        value: !this.main_data.loc_additional_data.value,
      });
    },
  },
};
</script>
